module.exports = __webpack_public_path__ + "img/sbj.157a5b5b.svg";